import React from 'react'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'

import ConstructionYear from '../common/ConstructionYear'
import Floor from '../common/Floor'
import Heat from '../common/Heat'
import HeatType from '../common/HeatType'
import Parking from '../common/Parking'
import ParkingSlots from '../common/ParkingSlots'
import Door from '../common/Door'
import EnergyClass from '../common/EnergyClass'
import Garden from '../common/Garden'
import GardenSqr from '../common/GardenSqr'
import FloorType from '../common/FloorType'
import Direction from '../common/Direction'
import View from '../common/View'
import Pool from '../common/Pool'
import Renovation from '../common/Renovation'
import RenovationYear from '../common/RenovationYear'
import Balcony from '../common/Balcony'
import Elevator from '../common/Elevator'
import Alarm from '../common/Alarm'
import Safe from '../common/Safe'
import UnderFloorHeat from '../common/UnderFloorHeat'
import Maintained from '../common/Maintained'
import DisabledAccess from '../common/DisabledAccess'
import Facade from '../common/Facade'
import Corner from '../common/Corner'
import AirCondition from '../common/AirCondition'
import ElectricityType from '../common/commercial/ElectricityType'
import Expandability from '../common/commercial/Expandability'
import ExpandabilitySqr from '../common/commercial/ExpandabilitySqr'
import StructuredWiring from '../common/commercial/StructuredWiring'
import Drains from '../common/land/Drains'
import FireSafety from '../common/commercial/FireSafety'
import Spaces from '../common/commercial/Spaces'
import FoodService from '../common/commercial/FoodService'
import Equipment from '../common/commercial/Equipment'
// import Equipped from '../common/commercial/Equipped'
import CargoRamp from '../common/commercial/CargoRamp'
import CargoElevator from '../common/commercial/CargoElevator'
import CargoElevatorLoad from '../common/commercial/CargoElevatorLoad'
// import CommercialPlot from '../common/commercial/CommercialPlot'
import Rooms from '../common/commercial/Rooms'
import WaterHeating from '../common/commercial/WaterHeating'
import Spa from '../common/commercial/Spa'
import RoofGarden from '../common/commercial/RoofGarden'
import Restaurant from '../common/commercial/Restaurant'
import RestaurantsCount from '../common/commercial/RestaurantsCount'
import SportFields from '../common/commercial/SportFields'
import EventSpaces from '../common/commercial/EventSpaces'
import SlopeAmphitheater from '../common/land/SlopeAmphitheater'
import WaterSupply from '../common/land/WaterSupply'
import Cellar from '../common/commercial/Cellar'
import OutBar from '../common/commercial/OutBar'
import StaffRooms from '../common/commercial/StaffRooms'
import OrganizedBeach from '../common/commercial/OrganizedBeach'
import MeetingRoom from '../common/commercial/MeetingRoom'
import Gyms from '../common/commercial/Gyms'
import { FormValues } from '..'
import PlotSqr from '../common/commercial/PlotSqr'
import BalconySqr from '../common/BalconySqr'
interface Props {
  control: Control<FormValues>
  trigger: UseFormTrigger<FormValues>
  getValues: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const CommercialHotelFields = (props: Props) => {
  const { control, trigger, getValues, resetField, setValue } = props
  return (
    <>
      <ConstructionYear
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Renovation
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <RenovationYear
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Floor
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Spaces
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Rooms
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Balcony
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <BalconySqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Heat
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <HeatType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Parking
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ParkingSlots
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Elevator
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Garden
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <GardenSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Door
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <View
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Alarm
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Safe
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <PlotSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <EnergyClass
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      {/* <Equipped
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      /> */}
      <Equipment
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <AirCondition
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ElectricityType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Expandability
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ExpandabilitySqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FoodService
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <WaterHeating
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FloorType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <UnderFloorHeat
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FireSafety
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Maintained
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Gyms
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Pool
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Spa
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <RoofGarden
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Restaurant
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <RestaurantsCount
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <SportFields
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <EventSpaces
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DisabledAccess
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Facade
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Corner
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Direction
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <SlopeAmphitheater
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoRamp
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoElevator
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoElevatorLoad
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <WaterSupply
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Drains
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <StructuredWiring
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Cellar
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <OutBar
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <StaffRooms
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <OrganizedBeach
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <MeetingRoom
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
    </>
  )
}

export default React.memo(CommercialHotelFields)
